<div id="statusTop" style="display: flex; flex-direction: column; gap: 5px; padding-top: 5px; padding-bottom: 5px">
  <div class="General efile-page">
    <h1>Online Forms Submission Status</h1>
    <div class="mb-1" style="text-align: right;">
      @if (fileItems()) {
        @let user = userService.user();
        @if (user) {
          <p class="efile-header" style="color: #043c5a">Welcome {{ user.lastName }}, {{ user.firstName }} {{ user.middleName }}</p>
        } @else {
          <p class="efile-header" style="color: #043c5a">Welcome</p>
        }
      }
    </div>
    <br>

    @if (recordsQuery.isPending()) {
      <div class="p-2" style="display: flex; align-items: center; justify-content: center; flex-direction: column">
        <app-loading-spinner></app-loading-spinner>
        <p style="color: black; margin-top: 10px">Retrieving your submissions...</p>
      </div>
    }

    @if (recordsQuery.isError()) {
      <div class="p-2"
           style="display: flex; align-items: center; justify-content: center; flex-direction: column; margin-bottom: 40px;">
        <h1 style="margin-bottom: 0">Load Failed</h1>
        <button class="btn btn-primary btn-assessor" (click)="retryButton()">Retry</button>
      </div>
    }

    @if (recordsQuery.isSuccess()) {
      <div class="table-wrapper">
        <table class="table">
          <thead class="header-mobile-label">
          <tr>
            <th scope="col">DATE</th>
            <th scope="col">WORK UNIT ID</th>
            <th scope="col">SUBMISSION ID</th>
            <th scope="col">FORM NAME / #</th>
            <th scope="col">AIN</th>
            <th scope="col">STATUS</th>
          </tr>
          </thead>
          <tbody>
            @for (item of fileItems(); track item) {
              <tr>
                <td><span class="mobile-label">DATE: </span>
                  <p [ngbTooltip]="formatLocalDateTime(item.dateCreated)">{{ item.date }}</p></td>
                <td><span class="mobile-label">WORK UNIT ID: </span> {{ getWorkUnitNumber(item) }}</td>
                <td><span class="mobile-label">SUBMISSION ID: </span> {{ item.id }}</td>
                <td><span class="mobile-label">FORM NAME / #: </span> {{ item.fileName }} <br> {{ item.description }}
                </td>
                <td><span class="mobile-label">AIN: </span> {{ item.ain }}</td>
                @if (shouldShowWUStart && item.workUnitId === 0) {
                  <td>
                    <button class="btn btn-primary btn-assessor"
                            (click)="manuallyKickOffWorkUnit(item)">{{ getCompleteButtonText(item) }}
                    </button>
                  </td>
                } @else {
                  @if (item.status === 'Pending Signature') {
                    <td><span class="mobile-label">STATUS: </span> <a (click)="accessLink(item.id)"
                                                                      style="color: blue">{{ item.status }}</a></td>
                  }
                  @if (item.status !== 'Pending Signature') {
                    <td><p class="mobile-label">STATUS: </p> {{ item.status }}</td>
                  }
                }
              </tr>
            }

          </tbody>
        </table>
      </div>
    }

    <div class="status-group">
      @if (ampOffline()) {
        <ngb-alert [dismissible]="false">
          <strong>Notice:</strong> The statuses displayed on this page may be out of date due to scheduled maintenance.
          Please check back later. Last updated: {{ lastUpdatedTime() | date:'medium' }}
        </ngb-alert>
      }

      <div class="accordion">
        <accordion [isAnimated]="true">
          <accordion-group #drop9 [isOpen]="true">
            <div accordion-heading>
                  <span class="dropdown-item clearfix">
                    STATUS LEGEND
                    <i
                      class="mt-1 float-end"
                      [ngClass]="!drop9.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
                    ></i>
                  </span>
            </div>
            <div style="border: 1px" class="w-100 legend">
              @for (item of legendItems; track item) {
                <p>
                  <span style="color: #3165b1">{{ item.name }}:</span> {{ item.description }}
                </p>
              }
            </div>

          </accordion-group>
        </accordion>
      </div>

      <div class="status-pagination-controls">
        <select class="form-select"
                style="width: auto"
                [ngModel]="pageSize()"
                (ngModelChange)="onPageSizeChange($event); scrollToTop()">
          <option [ngValue]="10">10 items per page</option>
          <option [ngValue]="20">20 items per page</option>
          <option [ngValue]="50">50 items per page</option>
        </select>

        <ngb-pagination
          [collectionSize]="collectionSize()"
          [page]="page()"
          (pageChange)="onPageChange($event); scrollToTop()"
          [pageSize]="pageSize()"
          [rotate]="true"
          [ellipses]="false"
          [boundaryLinks]="true"
          [maxSize]="3">
        </ngb-pagination>
      </div>
    </div>

  </div>
</div>

